import React, { Component } from 'react';

class getItemsv2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      modalX: 0,
      modalY: 0,
      modalContent: '',
    };
  }

  convertJavaColorToCSS = (javaColor) => {
    if (!javaColor) return "#dadada";
    let hexColor = `#${(javaColor & 0xFFFFFF).toString(16).padStart(6, '0')}`;
    return this.lightenColor(hexColor, 0.4);
  };

  lightenColor = (hex, percent) => {
    let num = parseInt(hex.slice(1), 16),
      r = (num >> 16),
      g = (num >> 8) & 0x00FF,
      b = num & 0x0000FF;

    r = Math.min(255, Math.floor(r + (255 - r) * percent));
    g = Math.min(255, Math.floor(g + (255 - g) * percent));
    b = Math.min(255, Math.floor(b + (255 - b) * percent));

    return `#${(1 << 24 | (r << 16) | (g << 8) | b).toString(16).slice(1)}`;
  };

  handleMouseEnter = (e, item) => {
    const rect = e.target.getBoundingClientRect();
    this.setState({
      showModal: true,
      modalX: rect.left + window.scrollX - 450,
      modalY: rect.top + window.scrollY ,
      modalContent: item.descripcion_flotante || 'Sin descripción',
    });
  };

  handleMouseLeave = () => {
    this.setState({ showModal: false });
  };

  mostrarItems = () => {
    const items = this.props.items;
    if (items.length === 0) return null;

    return (
      <React.Fragment>
        {items.map((item, index) => (
          <span
            key={item.id_item || `item-${index}`}
            className="boton_itemv2"
            onMouseEnter={item.id_producto ? (e) => this.handleMouseEnter(e, item) : undefined}
            onMouseLeave={item.id_producto ? this.handleMouseLeave : undefined}
          >
            <button
              className={(Number(item.activo)==1||!item.id_producto)?"boton_item_spanv2":"boton_item_spanv2_sin_stock"}
              style={(Number(item.activo)==1)?{
                backgroundColor: this.convertJavaColorToCSS(parseInt(item.color)),
              }:null}
              onClick={() =>
                this.props.recuperar_item(
                  item.id_sub_puntoventa_pantalla,
                  item.activo,
                  item.id_producto,
                  item.item,
                  item.precio_venta,
                  item.iva,
                  item.servicio,
                  item.w_incluido,
                  item.id_rubro,
                  item.id_subrubro,
                  item.pfinal,
                  item.id_combo,
                  item.carga_maxima,
                  item.uuid_imagen,
                  item.descripcion
                )
              }
            >
              {item.puntoventa_pantalla}
              {(Number(item.activo)==1||!item.id_producto)?"":"(Sin Stock)"}
            </button>
          </span>
        ))}
      </React.Fragment>
    );
  };

  render() {
    const { showModal, modalX, modalY, modalContent } = this.state;

    let data;
    if (this.props.ok_item === false) {
      data = (
        <div className="div_lbl_loading">
          <img
            alt="Cargando Imagen . . ."
            className="lbl_loading"
            src={null}
          />
        </div>
      );
    } else {
      data = <React.Fragment>{this.mostrarItems()}</React.Fragment>;
    }

    return (
      <React.Fragment>
        {data}

        {showModal && (
          <div
            style={{
              position: 'absolute',
              top: modalY,
              left: modalX,
              width: '400px',
              height: '200px',
              background: 'white',
              border: '1px solid #ccc',
              boxShadow: '0 4px 8px rgba(0,0,0,0.3)',
              padding: '20px',
              zIndex: 1100,
              borderRadius: '8px',
              overflowY: 'auto',
            }}
            dangerouslySetInnerHTML={{ __html: modalContent }}
          />
        )}
      </React.Fragment>
    );
  }
}

export default getItemsv2;